import styles from './eventPopup.module.scss';

export default function EventPopup({
  popupRef
}: {
  popupRef: React.RefObject<HTMLDivElement | null>;
}) {
  return <div ref={popupRef} className={styles.popup} />;
}
